export default "__VITE_ASSET__DgP3THL___";